import * as Matter from 'matter-js';

// The action bar (bottom-center) occupies roughly the bottom 70px of the canvas.
// A 110px-thick ground keeps the top of the ground comfortably above the action bar so
// the user can always see where things rest.
export const GROUND_HEIGHT = 110;

export function createGround(
  bounds: { width: number; height: number },
  friction = 0.3,
): Matter.Body {
  return Matter.Bodies.rectangle(
    bounds.width / 2,
    bounds.height - GROUND_HEIGHT / 2,
    bounds.width,
    GROUND_HEIGHT,
    { isStatic: true, friction },
  );
}

// Top edge of the ground in world coordinates. Scenes use this to position their bodies
// so they sit just above the ground.
export function groundTopY(bounds: { width: number; height: number }): number {
  return bounds.height - GROUND_HEIGHT;
}

// Static side walls just inside the canvas edges. Useful for any scene where dynamic
// bodies might roll off-screen (collisions, sandbox).
export function createWalls(
  bounds: { width: number; height: number },
  options: { thickness?: number; restitution?: number; friction?: number } = {},
): Matter.Body[] {
  const thickness = options.thickness ?? 20;
  const restitution = options.restitution ?? 0.4;
  const friction = options.friction ?? 0;
  const left = Matter.Bodies.rectangle(thickness / 2, bounds.height / 2, thickness, bounds.height, {
    isStatic: true,
    restitution,
    friction,
  });
  const right = Matter.Bodies.rectangle(
    bounds.width - thickness / 2,
    bounds.height / 2,
    thickness,
    bounds.height,
    { isStatic: true, restitution, friction },
  );
  return [left, right];
}
